function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import { KEY_ENTER, KEY_SPACE } from "@config/constants";
import React, { Component } from "react";
var ShareButton = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ShareButton, Component);
    var _super = _create_super(ShareButton);
    function ShareButton(props) {
        _class_call_check(this, ShareButton);
        var _this;
        _this = _super.call(this, props);
        _this.shareButton = null;
        _this.openFromKeyboard = _this.openFromKeyboard.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(ShareButton, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(param) {
                var playerOptionsAdditionalProps = param.playerOptionsAdditionalProps;
                if (this.props.playerOptionsAdditionalProps.isOpenShareList !== playerOptionsAdditionalProps.isOpenShareList && !this.props.playerOptionsAdditionalProps.isOpenShareList) {
                    this.shareButton.focus();
                }
            }
        },
        {
            /**
     * Opens the share list on space or enter keydown
     * @param event
     */ key: "openFromKeyboard",
            value: function openFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    this.props.actions.toggleShareList(true);
                    event.stopPropagation();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var actions = this.props.actions;
                return /*#__PURE__*/ _jsx("div", {
                    className: "share-button player-button",
                    onClick: function() {
                        return actions.toggleShareList(false);
                    },
                    onKeyDown: this.openFromKeyboard,
                    ref: function(node) {
                        return _this.shareButton = node;
                    },
                    tabIndex: "0",
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "icon icon-share pointer"
                    })
                });
            }
        }
    ]);
    return ShareButton;
}(Component);
export default ShareButton;
